




























import {Vue, Component, Prop, Mixins} from "vue-property-decorator";
import {mixins} from "vue-class-component"
import NotificationMixin from "./../mixins/NotificationMixin";
import { ISubmissionForm } from "../services/contactForm.service";


@Component({
    name: "ContactFormList",
})
export default class TestimonialList extends Mixins(NotificationMixin) {
    @Prop()
    public list!: ISubmissionForm[];

    private copyToClipboard(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            this.notifySuccess("Copied to clipboard");
        }).catch(() => {
            this.notifyError("Failed to copy");
        })
    }

    private async deleteSubmission(id: string) {
        this.$emit('delete', id);
    }
}

